<template>
  <div class="ecology">
    <!--  轮播-->
    <div class="swiper">
      <el-row>
        <el-col :span="12">
          <img src="../../../assets/ecology/ecology1.png" width="100%">
        </el-col>
        <el-col :span="12" style="padding-left: 15rem">
          <h3>合作共赢<br/>共享商业成功</h3>
          <h5>
            优质的合作伙伴，可靠的商业模式
          </h5>
          <div class="join-us-wrapper" style="text-align: right;margin-top: 5rem">
            <el-button type="primary" class="join-us-btn" @click="joinUsClick">
              加入我们&nbsp;&nbsp;&nbsp;➡
            </el-button>
          </div>
        </el-col>

      </el-row>
    </div>
    <!--我们的产品-->
    <section class="ecology1">
      <div class="wrap">
        <div class="name">
          <span>汇聚生态合力</span>
          <span>赋能产业蝶变</span>
          <span>引领商业创新未来</span>
        </div>
        <div
            style="display: flex; justify-content: center; align-items: center; flex-wrap: wrap; flex-direction: column">
          <div
              style="font-size: 2rem;font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;color: #333333;line-height: 3rem; width: 100%; margin-top: 7.6rem; width: 100%; margin: auto;">
            <p style="text-indent: 2em; font-size: 16px; margin-bottom: 4rem">
              以开放共赢为初心，聚力携手各方生态伙伴，凝聚起推动产业发展的磅礴合力，深度链接产业链上下游优质资源，打破行业间的信息壁垒、技术壁垒与合作壁垒，打通协同发展脉络，构建起互联互通、高效协同、资源共享、优势互补的产业生态网络。以前沿技术创新为核心引擎，以强大平台能力为坚实底座，整合数字技术、产业资源与服务能力，全面赋能传统产业突破发展瓶颈、实现蝶变跃升，推动产业结构优化升级与价值体系重构，助力万千企业加速数字化、智能化转型，破解发展难题，激活发展潜能。
            </p>
            <p style="text-indent: 2em;font-size: 16px; margin-bottom: 4rem">
              立足时代浪潮，紧跟全球科技前沿趋势，深耕多元应用场景创新，引领商业模式迭代变革，持续激发商业内生动力与无限活力，以创新之力领航新时代商业创新发展方向。我们始终秉持开放包容、共生共荣的理念，与所有生态伙伴并肩同行、同心致远，共建开放包容、合作共赢、可持续发展的产业新生态，共筑数字经济时代高质量发展的坚实根基，为产业长远发展注入持续不竭的动能，携手书写产业升级与商业创新的新篇章，共赴高质量发展的美好未来。</p>
          </div>
        </div>
      </div>
      <div class="wrap" style="padding-bottom: 15rem;padding-top: 0rem">
        <img src="../../../assets/ecology/newEcology1.png" style="width: 80%; margin: auto">
      </div>
    </section>

    <section class="ecology2">
      <div class="wrap">
        <div class="name">
          <span style="margin: 0">加入我们&nbsp;&nbsp;&nbsp;您将获得</span>
        </div>
        <div>
          <el-row :gutter="45">
            <!-- 卡片1 -->
            <el-col :span="6">
              <el-card
                  shadow="hover"
                  :body-style="hoverCardIndex === 0 ? { background: 'linear-gradient(to right, #ff0b41, #ff5252)' } : {}"
                  @mouseenter="onCardHover(0)"
                  @mouseleave="onCardLeave"
              >
                <div style="text-align: center;">
                  <div
                      style="display: flex; justify-content: center; align-items: center; margin-bottom: 3rem;margin-top: 3rem">
                    <img v-if="hoverCardIndex !== 0" src="../../../assets/ecology/newEcology2.png"
                         style="width: 6rem; height: 6rem; object-fit: contain;">
                    <img v-else src="../../../assets/ecology/newEcologyRed2.png"
                         style="width: 6rem; height: 6rem; object-fit: contain;">
                  </div>
                  <h3 :style="{ color: hoverCardIndex === 0 ? '#fff' : '' }"
                      style="font-weight: bold; margin-bottom: 3rem;font-size: 2rem">平台筑基・技术赋能</h3>
                  <p :style="{ color: hoverCardIndex === 0 ? '#fff' : '' }"
                     style="line-height: 1.8;margin-bottom: 4rem;font-size: 1.5rem">
                    专业平台强力支撑<br>
                    商业创新平台助力<br>
                    完备技术体系护航<br>
                    前沿技术资源共享
                  </p>
                </div>
              </el-card>
            </el-col>

            <!-- 卡片2 -->
            <el-col :span="6">
              <el-card
                  shadow="hover"
                  :body-style="hoverCardIndex === 1 ? { background: 'linear-gradient(to right, #ff0b41, #ff5252)' } : {}"
                  @mouseenter="onCardHover(1)"
                  @mouseleave="onCardLeave"
              >
                <div style="text-align: center;">
                  <div
                      style="display: flex; justify-content: center; align-items: center; margin-bottom: 3rem;margin-top: 3rem">
                    <img v-if="hoverCardIndex !== 1" src="../../../assets/ecology/newEcology3.png"
                         style="width: 6rem; height: 6rem; object-fit: contain;">
                    <img v-else src="../../../assets/ecology/newEcologyRed3.png"
                         style="width: 6rem; height: 6rem; object-fit: contain;">
                  </div>
                  <h3 :style="{ color: hoverCardIndex === 1 ? '#fff' : '' }"
                      style="font-weight: bold; margin-bottom: 3rem;font-size: 2rem">市场协同・互利共赢</h3>
                  <p :style="{ color: hoverCardIndex === 1 ? '#fff' : '' }"
                     style="line-height: 1.8;margin-bottom: 4rem;font-size: 1.5rem">
                    市场资源互通共享<br>
                    多方优势互补协同<br>
                    百万客户资源共享<br>
                    联合市场活动落地
                  </p>
                </div>
              </el-card>
            </el-col>

            <!-- 卡片3 -->
            <el-col :span="6">
              <el-card
                  shadow="hover"
                  :body-style="hoverCardIndex === 2 ? { background: 'linear-gradient(to right, #ff0b41, #ff5252)' } : {}"
                  @mouseenter="onCardHover(2)"
                  @mouseleave="onCardLeave"
              >
                <div style="text-align: center;">
                  <div
                      style="display: flex; justify-content: center; align-items: center; margin-bottom: 3rem;margin-top: 3rem">
                    <img v-if="hoverCardIndex !== 2" src="../../../assets/ecology/newEcology4.png"
                         style="width: 6rem; height: 6rem; object-fit: contain;">
                    <img v-else src="../../../assets/ecology/newEcologyRed4.png"
                         style="width: 6rem; height: 6rem; object-fit: contain;">
                  </div>
                  <h3 :style="{ color: hoverCardIndex === 2 ? '#fff' : '' }"
                      style="font-weight: bold; margin-bottom: 3rem;font-size: 2rem">能力升级・专业引领</h3>
                  <p :style="{ color: hoverCardIndex === 2 ? '#fff' : '' }"
                     style="line-height: 1.8;margin-bottom: 4rem;font-size: 1.5rem">
                    专业培训业务赋能<br>
                    专属技术认证体系<br>
                    通用能力认证支撑<br>
                    专业实力决胜市场
                  </p>
                </div>
              </el-card>
            </el-col>

            <!-- 卡片4 -->
            <el-col :span="6">
              <el-card
                  shadow="hover"
                  :body-style="hoverCardIndex === 3 ? { background: 'linear-gradient(to right, #ff0b41, #ff5252)' } : {}"
                  @mouseenter="onCardHover(3)"
                  @mouseleave="onCardLeave"
              >
                <div style="text-align: center;">
                  <div
                      style="display: flex; justify-content: center; align-items: center; margin-bottom: 3rem;margin-top: 3rem">
                    <img v-if="hoverCardIndex !== 3" src="../../../assets/ecology/newEcology5.png"
                         style="width: 6rem; height: 6rem; object-fit: contain;">
                    <img v-else src="../../../assets/ecology/newEcologyRed5.png"
                         style="width: 6rem; height: 6rem; object-fit: contain;">
                  </div>
                  <h3 :style="{ color: hoverCardIndex === 3 ? '#fff' : '' }"
                      style="font-weight: bold; margin-bottom: 3rem;font-size: 2rem">生态运营・全域服务</h3>
                  <p :style="{ color: hoverCardIndex === 3 ? '#fff' : '' }"
                     style="line-height: 1.8;margin-bottom: 4rem;font-size: 1.5rem">
                    跨领域技术深度融合<br>
                    全行业生态资源整合<br>
                    全方位运营服务保障<br>
                    全周期伙伴陪伴成长
                  </p>
                </div>
              </el-card>
            </el-col>
          </el-row>
          <div class="join-us-wrapper">
            <el-button type="primary" class="join-us-btn" @click="joinUsClick">
              加入我们&nbsp;&nbsp;&nbsp;➡
            </el-button>
          </div>
        </div>
      </div>
    </section>

    <section class="ecology3" style="padding-bottom: 20rem">
      <div class="wrap">
        <div class="name">
          <span style="margin: 0">共促伙伴发展&nbsp;&nbsp;&nbsp;坚守长期价值</span>
        </div>
        <div>
          <el-row :gutter="45">
            <!-- 卡片1 -->
            <el-col :span="8">
              <el-card shadow="hover">
                <div style="text-align: center;">
                  <h3 class="newEcology6">以专业谋发展</h3>
                  <p style="line-height: 1.8;margin-bottom: 2rem;margin-left:0.8rem;font-size: 1.5rem;text-align: left">
                    云创携手 ISV 伙伴、专业服务伙伴、战略联盟伙伴、教育伙伴及广大开发者，充分发挥各方专业优势，以更高标准的专业能力协同共创，为客户创造更高价值，筑牢更稳固的合作根基，共赴更广阔的发展未来。
                  </p>
                </div>
              </el-card>
            </el-col>

            <!-- 卡片2 -->
            <el-col :span="8">
              <el-card shadow="hover">
                <div style="text-align: center;">
                  <h3 class="newEcology7">以高效促运营</h3>
                  <p style="line-height: 1.8;margin-bottom: 2rem;margin-left:0.8rem;font-size: 1.5rem;text-align: left">
                    云创与生态伙伴秉持高效便捷的合作理念，持续优化技术赋能与业务支持体系，精简商务合作流程、完善伙伴引入与产品上架机制，以更高效便捷的全流程服务，助力伙伴快速融入云创生态，保障伙伴合法权益与长期发展。
                  </p>
                </div>
              </el-card>
            </el-col>

            <!-- 卡片3 -->
            <el-col :span="8">
              <el-card shadow="hover">
                <div style="text-align: center;">
                  <h3 class="newEcology8">以规模拓增长</h3>
                  <p style="line-height: 1.8;margin-bottom: 2rem;margin-left:0.8rem;font-size: 1.5rem;text-align: left">
                    企业数智化转型持续催生全新市场机遇，云创与全体伙伴深化协同，在深耕行业化、精进专业化的基础上，合力构建规模化服务能力，服务更广泛的企业客户，共同驱动业务增长，实现商业共赢。
                  </p>
                </div>
              </el-card>
            </el-col>

          </el-row>
          <div class="join-us-wrapper">
            <el-button type="primary" class="join-us-btn" @click="joinUsClick">
              加入我们&nbsp;&nbsp;&nbsp;➡
            </el-button>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// import Swiper, {Autoplay, Navigation, Pagination, Scrollbar} from "swiper";

export default {
  name: "ecologyIndex",
  data() {
    return {
      // 记录当前悬停的卡片索引 (-1表示未悬停)
      hoverCardIndex: -1,
      swiperimgData: [
        {
          name: '图片1',
          url: 'ecology/ecology1.png'
        }
      ],
    }
  },
  mounted() {

  },
  methods: {
    onCardHover(index) {
      this.hoverCardIndex = index;
    },
    onCardLeave() {
      this.hoverCardIndex = -1;
    },
    joinUsClick() {
      this.$store.state.components='joinUs'
      document.body.scrollTop=document.documentElement.scrollTop=0
    }

  }

}
</script>

<style lang="scss" scoped>
.swiper {
  width: 100%;
  background: url('../../../assets/ecology/ecology1bg.png') no-repeat;
  background-size: 100% 100%;

  .el-row {
    width: 120rem;
    min-width: 120rem;
    padding: 12rem 0 10rem;
    margin: auto;
    text-align: right;

    h3 {

      margin-top: 6rem;
      font-size: 5rem;
      margin-bottom: 2rem;
    }

    h5 {
      font-size: 2rem;
      font-weight: 400;
      color: #444955;
      line-height: 40px;
    }
  }
}

.ecology {
  padding-top: 0rem;
}

.wrap {
  width: 120rem;
  padding: 10rem 0;
  margin: auto;

  .name {
    font-size: 5rem;
    font-weight: 500;
    color: #000;
    text-align: center;
    margin-bottom: 10rem;
    display: flex;
    align-items: center;
    justify-content: center;

    span {
      margin: 0 5rem; /* 这里控制间距，自己调大小 */
    }
  }

  img {
    display: block
  }

  .imglist {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;

    .imgbox {
      width: 40rem;
      height: 42rem;
      margin-bottom: 4rem;
      display: flex;
      flex-direction: column;
      justify-items: center;
      align-items: center;
      border-radius: .4rem;
      align-items: center;
      background: #F8F8F8;

      img {
        width: 30%;
        margin-top: 7.2rem;
      }

      span {
        font-size: 2.8rem;
        margin-top: 4rem;
      }

      i {
        font-style: normal;
        font-size: 1.8rem;
        font-weight: 300;
        margin-top: .5rem;
      }

    }
  }

}

.ecology1 {
  background: url('../../../assets/ecology/ecologybg.png') no-repeat;
  background-size: cover;
}

.ecology2 {
  background: url('../../../assets/ecology/ecology3bg.png') no-repeat;
  background-size: cover;
}

.ecology3 {
  background: url('../../../assets/ecology/ecology4bg.png') no-repeat;
  background-size: cover;
}

.newEcology6 {
  color: white;
  font-size: 3.8rem;
  font-weight: 400;
  margin-left: -1rem;
  margin-top: -1rem;
  margin-bottom: 2rem;
  height: 15rem;
  width: 35rem;
  background: url('../../../assets/ecology/newEcology6.png') no-repeat;
  background-size: cover;

  /* --- 新增：垂直水平居中 --- */
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */

  /* --- 新增：字体间距（字间距） --- */
  letter-spacing: 0.3rem; /* 这里控制字与字之间的距离，可自行调整 */
}

.newEcology7 {
  color: white;
  font-size: 3.8rem;
  font-weight: 400;
  margin-left: -1rem;
  margin-top: -1rem;
  margin-bottom: 2rem;
  height: 15rem;
  width: 35rem;
  background: url('../../../assets/ecology/newEcology7.png') no-repeat;
  background-size: cover;

  /* --- 新增：垂直水平居中 --- */
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */

  /* --- 新增：字体间距（字间距） --- */
  letter-spacing: 0.3rem; /* 这里控制字与字之间的距离，可自行调整 */
}

.newEcology8 {
  color: white;
  font-size: 3.8rem;
  font-weight: 400;
  margin-left: -1rem;
  margin-top: -1rem;
  margin-bottom: 2rem;
  height: 15rem;
  width: 35rem;
  background: url('../../../assets/ecology/newEcology8.png') no-repeat;
  background-size: cover;

  /* --- 新增：垂直水平居中 --- */
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */

  /* --- 新增：字体间距（字间距） --- */
  letter-spacing: 0.3rem; /* 这里控制字与字之间的距离，可自行调整 */
}

.join-us-wrapper {
  text-align: center;
  margin-top: 10rem;
}

.join-us-btn {
  width: 20rem;
  height: 4.5rem;
  border-radius: 3rem;
  font-weight: 400;
  transition: all 0.3s ease;
  padding: 1.3rem 2.6rem;
  font-size: 2.5rem;
  background: linear-gradient(to right, #ff0b41, #ff5252);
  border: none;
  color: white;
  box-shadow: 0 4px 12px rgba(255, 11, 65, 0.3);


  &:hover {
    background: linear-gradient(to right, #e00a3b, #e94a4a);
    transform: translateY(-2px);
    box-shadow: 0 6px 15px rgba(255, 11, 65, 0.4);
    color: #fff;
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 2px 8px rgba(255, 11, 65, 0.3);
  }

}
</style>
